export default {
      id: "icon-CUSTOM-usage",
      viewBox: "0 0 32 32",
      url: "/" + "assets/sprite.svg#icon-CUSTOM",
      toString: function () {
        return this.url;
      }
    }